import script from "./nin_match_val.vue?vue&type=script&setup=true&lang=ts"
export * from "./nin_match_val.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__